import React, {useCallback, useEffect, useState} from "react";
import SynchronizationLogsDataTable from "@widgets/synchronization/overview/dataTable/SynchronizationLogsDataTable";
import SynchronizationOverviewHeading
    from "@widgets/synchronization/overview/heading/pageHeading/SynchronizationOverviewHeading";
import SynchronizeMenu from "@widgets/synchronization/synchronize/SynchronizeMenu";
import SynchronizationBusyNotification from "@widgets/synchronization/synchronize/SynchronizationBusyNotification";
import {useNotifications} from "peggirkit";
import {useIntl} from "react-intl";
import {notifyDanger} from "@/utils/NotifyUtils";
import {RestaurantSyncStatus} from "@/data/entities/sync";
import SynchronizationLogsSectionHeading
    from "@widgets/synchronization/overview/heading/sectionHeading/SynchronizationLogsSectionHeading";
import DeleteLogs from "@widgets/synchronization/overview/deletion/DeleteLogs";
import {api} from "@/data/api";


const SynchronizationOverview = () => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const [restaurantSyncStatus, setRestaurantSyncStatus] = useState<RestaurantSyncStatus | null>(null);
    const [loadingUpdatingStatus, setLoadingUpdatingStatus] = useState(false);
    const [showSynchronizationBusyModal, setShowSynchronizationBusyModal] = useState(false);
    const [showDeleteLogsModal, setShowDeleteLogsModal] = useState(false);
    const [showSynchronizeMenuModal, setShowSynchronizeMenuModal] = useState(false);
    const [logsLastUpdated, setLogsLastUpdated] = useState(new Date());
    const refreshSynchronizationStatus = useCallback(() => {
        api.sync.getSynchronizationStatus()
            .then((e: RestaurantSyncStatus) => setRestaurantSyncStatus(e))
            .catch((e) => {
                console.log(e);
                notifyDanger(intl.formatMessage({id: "systemError"}), notify);
            });
    }, [intl, notify])

    // Get initial current status
    useEffect(() => {
        refreshSynchronizationStatus();
    }, [refreshSynchronizationStatus]);

    // Refresh status and logs
    useEffect(() => {
        if (!loadingUpdatingStatus)
            return;

        setLogsLastUpdated(new Date());
        setLoadingUpdatingStatus(false);
        refreshSynchronizationStatus();
    }, [refreshSynchronizationStatus, loadingUpdatingStatus, setLogsLastUpdated, setLoadingUpdatingStatus,]);

    return (
        <>
            <SynchronizationOverviewHeading
                restaurantSyncStatus={restaurantSyncStatus}
                loadingUpdatingStatus={loadingUpdatingStatus}
                setLoadingUpdatingStatus={setLoadingUpdatingStatus}
                setShowSynchronizeMenuModal={setShowSynchronizeMenuModal}
            />

            <div className={"mt-8 md:mt-16"}>
                <SynchronizationLogsSectionHeading
                    setShowDeleteLogsModal={setShowDeleteLogsModal}
                />

                <SynchronizationLogsDataTable
                    logsLastUpdated={logsLastUpdated}
                />
            </div>

            <SynchronizeMenu
                show={showSynchronizeMenuModal}
                setShow={setShowSynchronizeMenuModal}
                setShowSynchronizationBusyModal={setShowSynchronizationBusyModal}
            />

            <SynchronizationBusyNotification
                show={showSynchronizationBusyModal}
                setShow={setShowSynchronizationBusyModal}
            />

            <DeleteLogs
                show={showDeleteLogsModal}
                setShow={setShowDeleteLogsModal}
                setLogsLastUpdated={setLogsLastUpdated}
            />
        </>
    );
};

export default SynchronizationOverview;